<template>
  <div>
  <v-menu v-model="datePickerVisible" :close-on-content-click="false" offset-y internal-activator class="d-block">
    <template v-slot:activator="{ on }">
      <v-text-field
        :hide-details="hideDetails"
        :value="textValue"
        @input="onTextInput"
        append-icon="mdi-menu-down"
        v-on="on"
      />
    </template>
    <v-date-picker
      :value="datePickerValue"
      @input="onDatePickerInput"
      locale="de-de"
      first-day-of-week="1"
    />
  </v-menu>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  props: [
    'value',
    'box',
    'hideDetails'
  ],
  data () {
    return {
      outputDateFormat: 'DD.MM.YYYY',
      datePickerFormat: 'YYYY-MM-DD',
      datePickerVisible: false,
      textValue: this.value ? this.value.format("DD.MM.YYYY") : "",
      inputFormats: [
        'DD.MM.YYYY',
        'YYYY-MM-DD',
      ],
    }
  },
  computed: {
    datePickerValue () {
      if (this.value && this.value.isValid()) {
        return this.value.format(this.datePickerFormat)
      } else {
        return null
      }
    },
  },
  watch: {
    value (newValue, oldValue) {
      this.textValue = newValue.format(this.outputDateFormat)
    },
  },
  methods: {
    onDatePickerInput (value) {
      this.$emit('input', moment(value))
      this.textValue = moment(value).format(this.outputDateFormat)
      this.datePickerVisible = false
    },
    onTextInput (textValue) {
      let value
      for (let i = 0; i < this.inputFormats.length; i++) {
        value = moment(textValue, this.inputFormats[i])
        if (value.isValid()) {
          break
        }
      }
      if (value.isValid() && 2000 <= value.year() && value.year() <= 2100 ) {
        this.$emit('input', value)
        this.textValue = value.format('DD.MM.YYYY')
      }
    },
  },
}
</script>

<style lang="scss">
</style>
